<template>
  <div class="app-whitelist-page">
    <div class="global-header-wrap">
      <div class="user-header-left">
        <div class="left-part">
          <span>应用</span>
          <div class="listSearch">
            <el-select
              v-model="packageName"
              clearable
              placeholder="请选择应用"
              @change="search"
              @clear="clearSearch('packageName')"
            >
              <el-option
                v-for="app in appOptions"
                :key="app.value"
                :label="app.label"
                :value="app.value"
              />
            </el-select>
          </div>
        </div>
        <div class="left-part">
          <span>MAC地址</span>
          <div class="listSearch">
            <el-input
              v-model="mac"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('mac')"
              placeholder="请输入MAC地址"
            />
          </div>
        </div>
        <div class="left-part">
          <span>设备型号</span>
          <div class="listSearch">
            <el-input
              v-model="model"
              clearable
              @keyup.enter.native="search"
              @clear="clearSearch('model')"
              placeholder="请输入设备型号"
            />
          </div>
        </div>
        <button class="global-button-style search-btn" @click="search">
          {{ $t("commonMsg.search") }}
        </button>
      </div>
      <div class="right-part">
        <button class="global-button-style" @click="handleAdd">
          <img src="@/assets/img/cmb_btn_add.png" />新增
        </button>
      </div>
    </div>

    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header" class="user-table-header">
        <p>总数：{{ total || 0 }}</p>
      </div>
      <div class="global-body-wrap" v-loading="loading">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="paramsList.pageSize"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSizeChange"
        :pageSizes="true"
      />
    </el-card>

    <el-dialog
      :title="editId ? '编辑应用白名单' : '新增应用白名单'"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleDialogClose"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="应用" prop="packageName">
          <el-select v-model="ruleForm.packageName" placeholder="请选择应用" style="width: 100%">
            <el-option
              v-for="app in appOptions"
              :key="app.value"
              :label="app.label"
              :value="app.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="设备标识" prop="deviceType">
          <el-select
            v-model="ruleForm.deviceType"
            placeholder="请选择设备标识类型"
            style="width: 100%"
            :disabled="!!editId"
            @change="handleFormDeviceTypeChange"
          >
            <el-option label="MAC地址" value="mac" />
            <el-option label="设备型号" value="model" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="ruleForm.deviceType === 'mac'" label="MAC地址" prop="mac">
          <el-input
            v-model="ruleForm.mac"
            placeholder="请输入设备MAC地址"
          />
        </el-form-item>
        <el-form-item v-if="ruleForm.deviceType === 'model'" label="设备型号" prop="model">
          <el-input
            v-model="ruleForm.model"
            placeholder="请输入设备型号"
            maxlength="15"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
    <opt-record-dialog ref="optRecordDialog" :fetchApi="fetchOptLogsApi" />
  </div>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import OptRecordDialog from "@/components/OptRecordDialog/index.vue";

export default {
  name: "AppWhitelist",
  components: {
    AppTable,
    Pagination,
    OptRecordDialog,
  },
  computed: {
    tableProps() {
      return [
        {
          prop: "appName",
          label: "应用名称",
        },
        {
          prop: "packageName",
          label: "包名",
        },
        {
          prop: "mac",
          label: "MAC地址",
        },
        {
          prop: "model",
          label: "设备型号",
        },
        {
          prop: "createdAt",
          label: "创建时间",
        },
        {
          prop: "updatedAt",
          label: "更新时间",
        },
        {
          prop: "handle",
          label: this.$t("org.manage"),
          width: 220,
          btn: [
            this.$t("commonMsg.edit"),
            this.$t("commonMsg.del"),
            "操作详情",
          ],
        },
      ];
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      packageName: "",
      mac: "",
      model: "",
      paramsList: { page: 1, pageSize: 20 },
      loading: false,
      dialogVisible: false,
      editId: null,
      ruleForm: {
        packageName: "",
        deviceType: "",
        mac: "",
        model: "",
      },
      rules: {
        packageName: [
          { required: true, message: "请选择应用", trigger: "change" },
        ],
        deviceType: [
          { required: true, message: "请选择设备标识类型", trigger: "change" },
        ],
        mac: [
          { required: true, message: "请输入MAC地址", trigger: "blur" },
          {
            pattern: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
            message: "MAC地址格式不正确，如：AA:BB:CC:DD:EE:FF",
            trigger: "blur",
          },
        ],
        model: [
          { required: true, message: "请输入设备型号", trigger: "blur" },
          { max: 15, message: "设备型号最多15个字符", trigger: "blur" },
        ],
      },
      appOptions: [
        { label: "Google Play", value: "com.android.vending" },
      ],
    };
  },
  methods: {
    async getAppWhitelist() {
      this.loading = true;
      try {
        const res = await this.$http.getAppWhitelist(this.paramsList);
        this.total = res.data.count || 0;
        const appMap = Object.fromEntries(this.appOptions.map((a) => [a.value, a.label]));
        this.tableData = (res.data.items || []).map((item) => ({
          ...item,
          appName: appMap[item.packageName] || item.packageName,
        }));
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      } finally {
        this.loading = false;
      }
    },

    search() {
      this.paramsList.page = 1;
      if (this.packageName) {
        this.paramsList.packageName = this.packageName;
      } else {
        delete this.paramsList.packageName;
      }
      if (this.mac) {
        this.paramsList.mac = this.mac;
      } else {
        delete this.paramsList.mac;
      }
      if (this.model) {
        this.paramsList.model = this.model;
      } else {
        delete this.paramsList.model;
      }
      this.getAppWhitelist();
    },

    clearSearch(type) {
      if (type === "packageName") this.packageName = "";
      else if (type === "mac") this.mac = "";
      else if (type === "model") this.model = "";
      this.search();
    },

    handleAdd() {
      this.editId = null;
      this.resetForm();
      this.dialogVisible = true;
    },

    async tableHandle(obj) {
      const row = obj.data && obj.data.row ? obj.data.row : obj.row;
      const id = row._id || row.id;

      if (!id) {
        this.$message({ type: "error", message: "无法获取记录ID" });
        return;
      }

      if (obj.type === this.$t("commonMsg.edit")) {
        this.editId = id;
        await this.getAppWhitelistDetail(id);
        this.dialogVisible = true;
      } else if (obj.type === this.$t("commonMsg.del")) {
        this.confirmDelete(id);
      } else if (obj.type === "操作详情") {
        this.handleShowOptLogs(id);
      }
    },

    async getAppWhitelistDetail(id) {
      try {
        const res = await this.$http.getAppWhitelistDetail(id);
        const { packageName, mac, model } = res.data;
        this.ruleForm = {
          packageName: packageName || "",
          deviceType: mac ? "mac" : "model",
          mac: mac || "",
          model: model || "",
        };
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      }
    },

    async confirmDelete(id) {
      if (!id) return;
      try {
        await this.$http.deleteAppWhitelist(id);
        this.$message({ type: "success", message: this.$t("alertMsg.delSuccess") });
        this.getAppWhitelist();
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      }
    },

    resetForm() {
      this.ruleForm = { packageName: "", deviceType: "", mac: "", model: "" };
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate();
      }
    },

    handleFormDeviceTypeChange() {
      this.ruleForm.mac = "";
      this.ruleForm.model = "";
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.clearValidate(["mac", "model"]);
      }
    },

    handleDialogClose() {
      this.resetForm();
      this.editId = null;
    },

    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this._doSubmit();
      });
    },

    async _doSubmit() {
      const params = this.$_.omitBy(this.ruleForm, (v) => !v);
      try {
        if (this.editId) {
          await this.$http.updateAppWhitelist(this.editId, params);
          this.$message({ type: "success", message: this.$t("alertMsg.editSuccess") });
        } else {
          await this.$http.createAppWhitelist(params);
          this.$message({ type: "success", message: this.$t("alertMsg.addSuccess") });
        }
        this.dialogVisible = false;
        this.getAppWhitelist();
      } catch {
        // 错误提示已由 axios 拦截器统一处理
      }
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getAppWhitelist();
    },

    pageSizeChange(size) {
      this.paramsList.pageSize = size;
      this.paramsList.page = 1;
      this.getAppWhitelist();
    },

    handleShowOptLogs(id) {
      this.$refs.optRecordDialog.open(id);
    },

    fetchOptLogsApi(id, params) {
      return this.$http.getAppWhitelistOptLogs(id, params);
    },
  },

  mounted() {
    this.getAppWhitelist();
  },
};
</script>

<style lang="scss" scoped>
.app-whitelist-page {
  height: 100%;
  display: flex;
  flex-direction: column;

  .global-header-wrap {
    padding: 10px 44px;
  }

  .user-header-left {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 12px;
    width: calc(100% - 120px);
    float: left;
  }

  .right-part {
    float: right;
    padding-top: 20px;
  }

  .left-part {
    display: flex;
    flex-direction: column;

    > span {
      margin-bottom: 6px;
      font-size: 14px;
    }

    .listSearch .el-input,
    .listSearch .el-select {
      width: 180px;
    }
  }

  .search-btn {
    margin-top: 0;
    align-self: flex-end;
  }

  .user-table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .form-tip {
    color: #f56c6c;
    font-size: 12px;
    padding-left: 100px;
    margin-top: -10px;
    margin-bottom: 10px;
  }

}
</style>
